import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "bnb-settlement",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        userId: this.$route.params.userId
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getBnbSettlementList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};